import React from "react";
import { Input } from "reactstrap";

export const TextWithSelect = ({
  onTextChange,
  value,
  onSelectChange,
  options,
  textClasses,
  sharedClasses,
  selectClasses,
  max,
  min,
}) => {
  return (
    <div className={`text-select-container bg-grey`}>
      <Input
        type="select"
        className={`custom-select text-selector ${selectClasses} ${sharedClasses}`}
        options={options}
        onChange={onSelectChange}
      >
        {options.map((option) => (
          <option key={option.id} value={option.value}>
            {option.label}
          </option>
        ))}
      </Input>
      <Input
        type="number"
        max={max}
        min={min}
        onChange={onTextChange}
        value={value}
        className={`custom-input ${textClasses} ${sharedClasses}`}
      />
    </div>
  );
};
